import { render, staticRenderFns } from "./leftBottom.vue?vue&type=template&id=199bc65c&scoped=true"
import script from "./leftBottom.vue?vue&type=script&lang=js"
export * from "./leftBottom.vue?vue&type=script&lang=js"
import style0 from "./leftBottom.vue?vue&type=style&index=0&id=199bc65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199bc65c",
  null
  
)

export default component.exports